module.exports = __webpack_public_path__ + "media/main_cards/schedule-83a293d7.svg";